import { Heart, Menu, Search, ShoppingCart } from "lucide-react";

export default function Header({ count, onCart, search, setSearch, menuOpen, setMenuOpen, user, onAccount }) {
  return (
    <>
      <div className="vf-topline">Livraison offerte dès 99 € · Retours gratuits sous 30 jours</div>
      <header className="vf-header">
        <div className="vf-header-main">
          <button className="vf-mobile-menu" onClick={() => setMenuOpen(!menuOpen)} data-testid="mobile-menu-button" aria-label="Menu"><Menu size={22} /></button>
          <a className="vf-logo" href="#top" data-testid="store-logo-link">Vibe<em>Fit</em></a>
          <div className="vf-search">
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Rechercher un produit..." data-testid="product-search-input" />
            <button data-testid="product-search-button" aria-label="Rechercher"><Search size={17} /></button>
          </div>
          <div className="vf-header-actions">
            <button className="vf-account" onClick={onAccount} data-testid="account-button">
              {user
                ? <>Bonjour, {(user.name || "").split(" ")[0]}<br /><b>Mes commandes</b></>
                : <>Bonjour, identifiez-vous<br /><b>Votre compte</b></>}
            </button>
            <button className="vf-wishlist" data-testid="wishlist-button"><Heart size={19} /><span>Favoris</span></button>
            <button className="vf-cart-btn" onClick={onCart} data-testid="header-cart-button">
              <ShoppingCart size={21} /><span>Panier</span>
              {count > 0 && <b className="vf-cart-count" data-testid="header-cart-count">{count}</b>}
            </button>
          </div>
        </div>
        <nav className={`vf-nav ${menuOpen ? "open" : ""}`} data-testid="category-navigation">
          <a href="#product" data-testid="category-fitness-link">Fitness & bien-être</a>
          <a href="#benefits" data-testid="category-benefits-link">Santé & relaxation</a>
          <a href="#reviews" data-testid="category-reviews-link">Meilleures ventes</a>
          <a href="#faq" data-testid="category-help-link">Besoin d&apos;aide ?</a>
          <a href="#product" className="vf-nav-highlight" data-testid="category-deals-link">Offres du moment</a>
        </nav>
      </header>
    </>
  );
}
